"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Health+Status
 */
var React = require("react");
var classNames = require("classnames");
var status_1 = require("./status");
var index_1 = require("../../index");
// Badges
var index_2 = require("./status-badges/index");
function chooseBadge(type) {
    switch (type) {
        case index_1.StatusShape.Circle:
            return index_2.SVGCircleBadge;
        case index_1.StatusShape.Square:
            return index_2.SVGSquareBadge;
        case index_1.StatusShape.Hexagon:
            return index_2.SVGHexagonBadge;
        case index_1.StatusShape.Stack:
            return index_2.SVGStackBadge;
        case index_1.StatusShape.Image:
            return undefined;
        default:
            throw new Error("Badge type: " + type + " is not configured in OUI-React StatusBadge.tsx");
    }
}
/**
 * OUI status badge component.
 *
 * @oui-component StatusBadge
 */
var StatusBadge = function (_a) {
    var statusType = _a.statusType, statusShapeText = _a.statusShapeText, statusImage = _a.statusImage, children = _a.children, testId = _a.testId, _b = _a.statusShape, statusShape = _b === void 0 ? index_1.StatusShape.Circle : _b;
    var colors = status_1.getStyles(statusType);
    var SVG = chooseBadge(statusShape);
    var trimmedStatusShapeText = statusShapeText.length > 3
        ? statusShapeText.substring(0, 3)
        : statusShapeText;
    return (React.createElement(React.Fragment, null, SVG ?
        React.createElement("div", { className: classNames(colors.statusBadge, "oui-status-badge__container"), "data-test-id": testId },
            React.createElement(SVG, { text: trimmedStatusShapeText }),
            children ? (React.createElement("p", { className: "oui-status-badge__status__label" }, children)) : null)
        :
            statusShape === index_1.StatusShape.Image &&
                React.createElement("div", { className: classNames(colors.statusBadge, "oui-status-badge__container", "oui-status-badge__image-container") },
                    React.createElement("img", { title: statusShapeText, src: statusImage }),
                    children ? (React.createElement("p", { className: "oui-status-badge__status__label" }, children)) : null)));
};
/**
 * A status badge component.
 */
exports.default = StatusBadge;
//# sourceMappingURL=StatusBadge.js.map